var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { isEqual } from 'lodash';
import * as moment from 'moment-timezone';
import formatTime, { formatDate } from '../../../utils/format_time';
export var budgetDaysShorthandText = function (days) {
    // show ranged days if each day is 1 more than the previous
    // if days are Mon, Tue, Wed, Thu -- it should show ranged days
    // if days are Mon, Wed, Thu -- it should not show ranged days
    var shouldShowRangedDays = true;
    days.forEach(function (day, index) {
        if (index === 0) {
            return;
        }
        if (day === days[index - 1] + 1) {
            return;
        }
        shouldShowRangedDays = false;
    });
    if (shouldShowRangedDays) {
        var firstDayOfWeek = days[0];
        var formattedFirstDayOfWeek = moment(firstDayOfWeek, 'E').format('ddd');
        if (days.length === 1) {
            return "" + formattedFirstDayOfWeek;
        }
        var lastDayOfWeek = days[days.length - 1];
        var formattedLastDayOfWeek = moment(lastDayOfWeek, 'E').format('ddd');
        // e.g. "Mon–Thu"
        return formattedFirstDayOfWeek + "\u2013" + formattedLastDayOfWeek;
    }
    // e.g. "Mon, Wed, Thu"
    return days
        .map(function (day) {
        var formattedDayOfWeek = moment(day, 'E').format('ddd');
        return "" + formattedDayOfWeek;
    })
        .join(', ');
};
export var budgetTimesShorthandText = function (startTimeHours, startTimeMinutes, endTimeHours, endTimeMinutes) {
    var startTime = startTimeHours + ":" + startTimeMinutes;
    var endTime = endTimeHours + ":" + endTimeMinutes;
    var formattedStartTime = moment(startTime, 'H:m').format('LT');
    var formattedEndTime = moment(endTime, 'H:m').format('LT');
    return formattedStartTime + "\u2013" + formattedEndTime;
};
function timesExistForAllAvs(availabilitiesList) {
    return availabilitiesList.every(function (av) {
        return Boolean(av.startTimeOfDayOfWeek &&
            av.startTimeOfDayOfWeek.dayOfWeek &&
            av.startTimeOfDayOfWeek.timeOfDay &&
            av.endTimeOfDayOfWeek &&
            av.endTimeOfDayOfWeek.dayOfWeek &&
            av.endTimeOfDayOfWeek.timeOfDay);
    });
}
export var budgetTimeSummaryText = function (availabilitiesList) {
    try {
        if (availabilitiesList.length === 0) {
            return 'N/A';
        }
        if (!timesExistForAllAvs(availabilitiesList)) {
            return 'N/A';
        }
        var _a = availabilitiesList[0], _b = _a.startTimeOfDayOfWeek.timeOfDay, firstAvStartHours_1 = _b.hours, firstAvStartMinutes_1 = _b.minutes, _c = _a.endTimeOfDayOfWeek.timeOfDay, firstAvEndHours_1 = _c.hours, firstAvEndMinutes_1 = _c.minutes;
        // summarize times if all the times are the same each day
        var shouldSummarizeTimes = availabilitiesList.every(function (av) {
            var _a = av.startTimeOfDayOfWeek.timeOfDay, avStartHours = _a.hours, avStartMinutes = _a.minutes, _b = av.endTimeOfDayOfWeek.timeOfDay, avEndHours = _b.hours, avEndMinutes = _b.minutes;
            return (avStartHours === firstAvStartHours_1 &&
                avStartMinutes === firstAvStartMinutes_1 &&
                avEndHours === firstAvEndHours_1 &&
                avEndMinutes === firstAvEndMinutes_1);
        });
        if (shouldSummarizeTimes) {
            // if times can be summarized, days can be summarized too
            var summarizedDaysText = budgetDaysShorthandText(availabilitiesList.map(function (av) { return av.startTimeOfDayOfWeek.dayOfWeek; }));
            var summarizedTimesText = budgetTimesShorthandText(firstAvStartHours_1, firstAvStartMinutes_1, firstAvEndHours_1, firstAvEndMinutes_1);
            // e.g. "Mon–Thu (11:00 AM–5:00 PM)"
            return summarizedDaysText + " (" + summarizedTimesText + ")";
        }
        var longSummaryText = availabilitiesList
            .map(function (av) {
            var _a = av.startTimeOfDayOfWeek, avStartDayOfWeek = _a.dayOfWeek, _b = _a.timeOfDay, avStartHours = _b.hours, avStartMinutes = _b.minutes, _c = av.endTimeOfDayOfWeek.timeOfDay, avEndHours = _c.hours, avEndMinutes = _c.minutes;
            var dayOfWeek = avStartDayOfWeek;
            var startTime = avStartHours + ":" + avStartMinutes;
            var endTime = avEndHours + ":" + avEndMinutes;
            var formattedDayOfWeek = moment(dayOfWeek, 'E').format('ddd');
            var formattedStartTime = moment(startTime, 'H:m').format('LT');
            var formattedEndTime = moment(endTime, 'H:m').format('LT');
            return formattedDayOfWeek + " (" + formattedStartTime + "\u2013" + formattedEndTime + ")";
        })
            .join(', ');
        // e.g. "Mon (11:00 AM–5:00 PM), Wed (11:00 AM–4:00 PM), Fri (11:00 AM–5:00 PM)"
        return longSummaryText;
    }
    catch (e) {
        return 'N/A';
    }
};
var NUM_BASE_BUDGET_TIMES = 48;
// array of times in string format from 00:00 to 23:30 in 30-min increments
var budgetTimes = Array.from({
    length: NUM_BASE_BUDGET_TIMES,
}, function (_, x) {
    return moment({
        hour: Math.floor(x / 2),
        minutes: x % 2 === 0 ? 0 : 30,
    }).format('HH:mm');
});
// array of times in string format from 00:00 to 23:30 in 30-min increments
export var budgetStartTimes = budgetTimes.slice(0, NUM_BASE_BUDGET_TIMES);
// array of times in string format from 00:30 to 23:59 in 30-min increments
export var budgetEndTimes = __spread(budgetTimes.slice(1, NUM_BASE_BUDGET_TIMES), [
    '23:59',
]);
var BUDGET_DAYS_SELECT_VALUE_DAILY = 'daily';
var BUDGET_DAYS_SELECT_VALUE_WEEKDAYS = 'weekdays';
var BUDGET_DAYS_SELECT_VALUE_WEEKENDS = 'weekends';
export var BUDGET_DAYS_SELECT_VALUE_CUSTOM = 'custom';
export var BUDGET_DAYS_NAMES = [
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
    'Sun',
];
var BUDGET_DAYS_LIST_DAILY = ['1', '2', '3', '4', '5', '6', '7'];
var BUDGET_DAYS_LIST_WEEKDAYS = ['1', '2', '3', '4', '5'];
var BUDGET_DAYS_LIST_WEEKENDS = ['6', '7'];
var BUDGET_DAYS_LIST_CUSTOM = [];
export var BUDGET_TYPE_SELECT = ['Recurring', 'One time'];
export var EXPENSE_CODE_SELECT = [
    'Optional',
    'Required',
    'Required from list',
];
export var EXPENSE_CODE_MODE_MAPPING;
(function (EXPENSE_CODE_MODE_MAPPING) {
    EXPENSE_CODE_MODE_MAPPING[EXPENSE_CODE_MODE_MAPPING["NotRequired"] = 0] = "NotRequired";
    EXPENSE_CODE_MODE_MAPPING[EXPENSE_CODE_MODE_MAPPING["Optional"] = 1] = "Optional";
    EXPENSE_CODE_MODE_MAPPING[EXPENSE_CODE_MODE_MAPPING["Required"] = 2] = "Required";
    EXPENSE_CODE_MODE_MAPPING[EXPENSE_CODE_MODE_MAPPING["Required from list"] = 4] = "Required from list";
})(EXPENSE_CODE_MODE_MAPPING || (EXPENSE_CODE_MODE_MAPPING = {}));
export var BUDGET_REFRESH_INTERVAL;
(function (BUDGET_REFRESH_INTERVAL) {
    BUDGET_REFRESH_INTERVAL[BUDGET_REFRESH_INTERVAL["Default"] = 0] = "Default";
    BUDGET_REFRESH_INTERVAL[BUDGET_REFRESH_INTERVAL["OneTime"] = 1] = "OneTime";
    BUDGET_REFRESH_INTERVAL[BUDGET_REFRESH_INTERVAL["Daily"] = 2] = "Daily";
    BUDGET_REFRESH_INTERVAL[BUDGET_REFRESH_INTERVAL["Weekly"] = 3] = "Weekly";
    BUDGET_REFRESH_INTERVAL[BUDGET_REFRESH_INTERVAL["Monthly"] = 4] = "Monthly";
})(BUDGET_REFRESH_INTERVAL || (BUDGET_REFRESH_INTERVAL = {}));
export var getBudgetTypeSelect = function (budgetRefreshInterval) {
    // if budgetRefreshInterval is "one time", then return the correlating value
    // everything else is considered "recurring" which correlates to 0
    if (budgetRefreshInterval === 1) {
        return 1;
    }
    return 0;
};
export var budgetTypeRecurringOptions = [
    { label: 'Daily', value: 2 },
    { label: 'Weekly', value: 3 },
    { label: 'Monthly', value: 4 },
];
export var commonDaysSelectOptions = [
    {
        label: 'Every day',
        value: BUDGET_DAYS_SELECT_VALUE_DAILY,
        daysList: BUDGET_DAYS_LIST_DAILY,
    },
    {
        label: 'Weekdays only (Mon–Fri)',
        value: BUDGET_DAYS_SELECT_VALUE_WEEKDAYS,
        daysList: BUDGET_DAYS_LIST_WEEKDAYS,
    },
    {
        label: 'Weekends only (Sat–Sun)',
        value: BUDGET_DAYS_SELECT_VALUE_WEEKENDS,
        daysList: BUDGET_DAYS_LIST_WEEKENDS,
    },
];
export var daysSelectOptions = __spread(commonDaysSelectOptions, [
    {
        label: 'Custom',
        value: BUDGET_DAYS_SELECT_VALUE_CUSTOM,
        daysList: BUDGET_DAYS_LIST_CUSTOM,
    },
]);
// given a daysList in format ['1', '2', '3']
// return the value selected in the daysSelect
export var getDaysSelectValue = function (daysList) {
    var daysSelectValue = BUDGET_DAYS_SELECT_VALUE_CUSTOM;
    commonDaysSelectOptions.forEach(function (obj) {
        if (isEqual(obj.daysList, daysList)) {
            daysSelectValue = obj.value;
        }
    });
    return daysSelectValue;
};
// given a daysSelectValue string (e.g. 'daily' or 'weekends')
// return the daysList in format ['1', '2', '3']
export var getDaysList = function (daysSelectValue) {
    var daysSelectOption = daysSelectOptions.find(function (el) { return el.value === daysSelectValue; });
    return (daysSelectOption === null || daysSelectOption === void 0 ? void 0 : daysSelectOption.daysList) || BUDGET_DAYS_LIST_CUSTOM;
};
var BUDGET_TIMES_SELECT_VALUE_ANYTIME = 'anytime';
var BUDGET_TIMES_SELECT_VALUE_WORKDAY = 'workday';
var BUDGET_TIMES_SELECT_VALUE_BREAKFAST = 'breakfast';
var BUDGET_TIMES_SELECT_VALUE_LUNCH = 'lunch';
var BUDGET_TIMES_SELECT_VALUE_DINNER = 'dinner';
export var BUDGET_TIMES_SELECT_VALUE_CUSTOM = 'custom';
var BUDGET_TIMES_FOR_ANYTIME = {
    startTime: '00:00',
    endTime: '23:59',
};
var BUDGET_TIMES_FOR_WORKDAY = {
    startTime: '09:00',
    endTime: '18:00',
};
var BUDGET_TIMES_FOR_BREAKFAST = {
    startTime: '06:00',
    endTime: '10:00',
};
var BUDGET_TIMES_FOR_LUNCH = {
    startTime: '11:00',
    endTime: '14:00',
};
var BUDGET_TIMES_FOR_DINNER = {
    startTime: '19:00',
    endTime: '22:00',
};
var BUDGET_TIMES_FOR_CUSTOM = {
    startTime: '',
    endTime: '',
};
export var commonTimesSelectOptions = [
    {
        label: 'Anytime',
        value: BUDGET_TIMES_SELECT_VALUE_ANYTIME,
        startTime: BUDGET_TIMES_FOR_ANYTIME.startTime,
        endTime: BUDGET_TIMES_FOR_ANYTIME.endTime,
    },
    {
        label: 'Working hours (9 AM to 6 PM)',
        value: BUDGET_TIMES_SELECT_VALUE_WORKDAY,
        startTime: BUDGET_TIMES_FOR_WORKDAY.startTime,
        endTime: BUDGET_TIMES_FOR_WORKDAY.endTime,
    },
    {
        label: 'Breakfast (6 AM to 10 AM)',
        value: BUDGET_TIMES_SELECT_VALUE_BREAKFAST,
        startTime: BUDGET_TIMES_FOR_BREAKFAST.startTime,
        endTime: BUDGET_TIMES_FOR_BREAKFAST.endTime,
    },
    {
        label: 'Lunch (11 AM to 2 PM)',
        value: BUDGET_TIMES_SELECT_VALUE_LUNCH,
        startTime: BUDGET_TIMES_FOR_LUNCH.startTime,
        endTime: BUDGET_TIMES_FOR_LUNCH.endTime,
    },
    {
        label: 'Dinner (7 PM to 10 PM)',
        value: BUDGET_TIMES_SELECT_VALUE_DINNER,
        startTime: BUDGET_TIMES_FOR_DINNER.startTime,
        endTime: BUDGET_TIMES_FOR_DINNER.endTime,
    },
];
export var timesSelectOptions = __spread(commonTimesSelectOptions, [
    {
        label: 'Custom',
        value: BUDGET_TIMES_SELECT_VALUE_CUSTOM,
        startTime: BUDGET_TIMES_FOR_CUSTOM.startTime,
        endTime: BUDGET_TIMES_FOR_CUSTOM.endTime,
    },
]);
// given a start and end time
// return the value selected in the timesSelect
export var getTimesSelectValue = function (startTime, endTime) {
    var timesSelectValue = BUDGET_TIMES_SELECT_VALUE_CUSTOM;
    commonTimesSelectOptions.forEach(function (obj) {
        if (obj.startTime === startTime && obj.endTime === endTime) {
            timesSelectValue = obj.value;
        }
    });
    return timesSelectValue;
};
// given a timesSelectValue (e.g. 'breakfast' or 'lunch')
// return an object with the start and end time
export var getTimesForOption = function (timesSelectValue) {
    var timesSelectOption = timesSelectOptions.find(function (el) { return el.value === timesSelectValue; });
    var startTime = timesSelectOption
        ? timesSelectOption.startTime
        : BUDGET_TIMES_FOR_CUSTOM.startTime;
    var endTime = timesSelectOption
        ? timesSelectOption.endTime
        : BUDGET_TIMES_FOR_CUSTOM.endTime;
    return {
        startTime: startTime,
        endTime: endTime,
    };
};
export var formValuesForNewBudget = {
    budgetName: '',
    budgetDaysSelect: BUDGET_DAYS_SELECT_VALUE_DAILY,
    budgetDaysList: BUDGET_DAYS_LIST_DAILY,
    budgetTimesSelect: BUDGET_TIMES_SELECT_VALUE_ANYTIME,
    budgetStartTime: '00:00',
    budgetEndTime: '23:59',
    budgetUnitAmount: '',
    budgetAddressText: '',
    budgetExpenseCodeMode: false,
    expenseCodeEnforcementMode: 0,
    expenseCodeValidValues: '',
    // restaurant is default for now. Cx will not be able to exclude
    permittedOrderContentsList: [1],
};
export var formValuesForNewFlexibleBudget = __assign(__assign({}, formValuesForNewBudget), { budgetTypeSelect: getBudgetTypeSelect(BUDGET_REFRESH_INTERVAL.Daily), budgetRefreshInterval: BUDGET_REFRESH_INTERVAL.Daily, budgetActiveDate: formatDate(new Date(Date.now())), budgetInactiveDate: '' });
var isExpenseCodeModeOn = function (val) {
    if (val && val > 0) {
        // mode value Required(2), Optional(1), toggle is on
        return true;
    }
    return false;
};
// get initial form values for Add Budget Modal Form
export var getFormValuesForBudget = function (budget) {
    var _a, _b, _c, _d, _e, _f;
    var name = budget.name, availabilitiesList = budget.availabilitiesList;
    var unitAmount = ((_a = budget.maximumAllotment) === null || _a === void 0 ? void 0 : _a.unitAmount) ? (((_b = budget.maximumAllotment) === null || _b === void 0 ? void 0 : _b.unitAmount) / 100).toString()
        : '0';
    var budgetAddressText = '';
    if (budget.addressId) {
        if (budget.address && budget.address.printableAddress) {
            budgetAddressText = budget.address.printableAddress;
        }
        else {
            // This is for the rare case that Geo Intel Service is down.
            // We know it's restricted but we don't have a human-readable address.
            budgetAddressText = 'Restricted';
        }
    }
    if (availabilitiesList.length === 0 ||
        !timesExistForAllAvs(availabilitiesList)) {
        return __assign(__assign({}, formValuesForNewBudget), { budgetName: name, budgetUnitAmount: unitAmount, budgetAddressText: budgetAddressText });
    }
    var _g = availabilitiesList[0], _h = _g.startTimeOfDayOfWeek.timeOfDay, firstAvStartHours = _h.hours, firstAvStartMinutes = _h.minutes, _j = _g.endTimeOfDayOfWeek.timeOfDay, firstAvEndHours = _j.hours, firstAvEndMinutes = _j.minutes;
    var daysList = availabilitiesList.map(function (av) {
        return av.startTimeOfDayOfWeek.dayOfWeek.toString();
    });
    var daysSelect = getDaysSelectValue(daysList);
    var givenStartTime = moment({
        hour: firstAvStartHours,
        minutes: firstAvStartMinutes,
    }).format('HH:mm');
    var givenEndTime = moment({
        hour: firstAvEndHours,
        minutes: firstAvEndMinutes,
    }).format('HH:mm');
    var startTime = budgetStartTimes.includes(givenStartTime)
        ? givenStartTime
        : '';
    var endTime = budgetEndTimes.includes(givenEndTime) ? givenEndTime : '';
    var timesSelect = getTimesSelectValue(startTime, endTime);
    return {
        budgetName: name,
        budgetDaysSelect: daysSelect,
        budgetDaysList: daysList,
        budgetTimesSelect: timesSelect,
        budgetStartTime: startTime,
        budgetEndTime: endTime,
        budgetUnitAmount: unitAmount,
        budgetAddressText: budgetAddressText,
        budgetGroups: budget.groups,
        budgetExpenseCodeMode: isExpenseCodeModeOn((_c = budget.expenseCodeConfig) === null || _c === void 0 ? void 0 : _c.expenseCodeEnforcementMode),
        expenseCodeEnforcementMode: (_d = budget.expenseCodeConfig) === null || _d === void 0 ? void 0 : _d.expenseCodeEnforcementMode,
        expenseCodeValidValues: (_e = budget.expenseCodeConfig) === null || _e === void 0 ? void 0 : _e.expenseCodeValidValuesList.join(', '),
        permittedOrderContentsList: (_f = budget.budgetConfig) === null || _f === void 0 ? void 0 : _f.permittedOrderContentsList,
    };
};
export var getFormValuesForFlexibleBudget = function (budget) {
    var _a, _b, _c;
    if (!budget)
        return formValuesForNewFlexibleBudget;
    return __assign(__assign({}, getFormValuesForBudget(budget)), { budgetTypeSelect: getBudgetTypeSelect((_a = budget.refreshInterval) !== null && _a !== void 0 ? _a : 0), budgetActiveDate: ((_b = budget.activeAtTimestamp) === null || _b === void 0 ? void 0 : _b.seconds) ? moment(budget.activeAtTimestamp.seconds, 'X').format('MM/DD/YYYY')
            : '', budgetInactiveDate: ((_c = budget.inactiveAtTimestamp) === null || _c === void 0 ? void 0 : _c.seconds) ? moment(budget.inactiveAtTimestamp.seconds, 'X').format('MM/DD/YYYY')
            : '', budgetRefreshInterval: budget.refreshInterval });
};
export var getPrintedAddressForBudget = function (budget) {
    var printedAddress = 'Anywhere';
    if (budget.addressId) {
        if (budget.address && budget.address.printableAddress) {
            printedAddress = budget.address.printableAddress;
        }
        else {
            // This is for the rare case that Geo Intel Service is down.
            // We know it's restricted but we don't have a human-readable address.
            printedAddress = 'Restricted';
        }
    }
    return printedAddress;
};
export var getBudgetActiveDatesSummary = function (budget) {
    var _a, _b;
    var activeAt = ((_a = budget.activeAtTimestamp) === null || _a === void 0 ? void 0 : _a.seconds) ? formatTime(budget.activeAtTimestamp.seconds.toString(), 'X', 'M/D/YY')
        : 'Unknown Date';
    var additionalStringForInactiveAt = ((_b = budget.inactiveAtTimestamp) === null || _b === void 0 ? void 0 : _b.seconds) ? " \u2013 " + formatTime(budget.inactiveAtTimestamp.seconds.toString(), 'X', 'M/D/YY')
        : '';
    return "" + activeAt + additionalStringForInactiveAt;
};
export var BUDGET_TYPE_STRINGS = [
    'Default Interval',
    'One Time',
    'Recurring Daily',
    'Recurring Weekly',
    'Recurring Monthly',
];
export var getBudgetTypeSummary = function (budget) {
    if (budget.refreshInterval &&
        budget.refreshInterval < BUDGET_TYPE_STRINGS.length) {
        return BUDGET_TYPE_STRINGS[budget.refreshInterval];
    }
    return 'Unknown Type';
};
export var getArrayFromExpenseCodeValues = function (values) {
    if (values && values.trim()) {
        return values.trim().split(/[\s,]+/);
    }
    return [];
};
export var isContainValidChars = function (values) {
    var e_1, _a;
    /*
      Match any character that is NOT in the following set:
      word
      spacing
      -:,+.@
      (these symbols are allowed)
     */
    /*
      Same code validation pattern from app-consumer
      https://github.com/doordash/web/blob/a9ab484f7d422727dda632f27131924252e051e1/packages/app-consumer/src/Team/Providers/TeamBudgetCheckout.tsx#L78
     */
    var disallowedPattern = /([^\w\s-:,+\.@])/;
    var expenseCodeList = getArrayFromExpenseCodeValues(values);
    try {
        for (var expenseCodeList_1 = __values(expenseCodeList), expenseCodeList_1_1 = expenseCodeList_1.next(); !expenseCodeList_1_1.done; expenseCodeList_1_1 = expenseCodeList_1.next()) {
            var code = expenseCodeList_1_1.value;
            if (disallowedPattern.test(code))
                return false;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (expenseCodeList_1_1 && !expenseCodeList_1_1.done && (_a = expenseCodeList_1.return)) _a.call(expenseCodeList_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
};
var EXPENSE_CODE_MAX_LENGTH = 50;
export var isWithinMaxLength = function (values) {
    var e_2, _a;
    var expenseCodeList = getArrayFromExpenseCodeValues(values);
    var codeMaxLength = EXPENSE_CODE_MAX_LENGTH;
    try {
        for (var expenseCodeList_2 = __values(expenseCodeList), expenseCodeList_2_1 = expenseCodeList_2.next(); !expenseCodeList_2_1.done; expenseCodeList_2_1 = expenseCodeList_2.next()) {
            var code = expenseCodeList_2_1.value;
            if (code.length > codeMaxLength)
                return false;
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (expenseCodeList_2_1 && !expenseCodeList_2_1.done && (_a = expenseCodeList_2.return)) _a.call(expenseCodeList_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return true;
};
